<template>
  <v-dialog v-model="dialog" max-width="80%" max-height="80%" persistent>
    <v-card style="position: relative;">
      <v-card-title class="title pb-0">
        <span>Thay đổi người quản lí</span>
        <v-spacer></v-spacer>
        <v-btn icon ripple flat @click="close">
          <v-icon color="black">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
<!--  -->
      <v-text-field flat
                    solo
                    hide-details
                    prepend-icon="search"
                    placeholder="Tìm trên danh sách đại lý"
                    v-model="table.searchText"
                    v-on:keyup.enter="search()">
      </v-text-field>
      <v-data-table item-key="id"
                :headers="table.headers"
                :items="accounts"
                :rows-per-page-items="[10,20,50,100]"
                :loading="loading"
                @update:pagination="changePage"
                :total-items="totalItems"
                >
          <template slot="items" slot-scope="props">
              <td >{{ props.item.dealerName }}</td>
              <td>{{props.item.name}}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.address }}</td>
              <td>
                  <v-tooltip bottom>
                    <v-btn icon slot="activator" @click="changeManager(props.item.id)">
                      <v-icon>check</v-icon>
                    </v-btn>
                    <span>Chọn</span>
                  </v-tooltip>
              </td>
          </template>
        </v-data-table>
<!--  -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {  mapActions } from 'vuex';
import { getAccounts, updatemanageduser } from '../../api/account';
export default {
  data: () => ({
    table: {
      searchText: '',
      headers: [
        {
          text: 'Nhà phân phối / Đại lý',
          value: 'dealerName'
        },
        {
          text: 'Khách hàng',
          value: 'name'
        },
        {
          text: 'SĐT',
          value: 'phone'
        },
        {
          text: 'Địa chỉ',
          value: 'address'
        },
        {
          text: '',
          value: '#'
        }
      ]
    },
    dialog: false,
    pagination: {
      keySearch: '',
      pageIndex: 1,
      pageSize: 10,
      filter: 'Dealer'
    },
    accounts: [],
    totalItems: 0,
    loading: false,
    item: null
  }),

  methods: {
    ...mapActions(['getAccounts']),

    fetchDealerAccounts () {
      this.loading = true;
      getAccounts(this.pagination).then(response => {
        let result = response.data;
        if (!result.code && result.data) {
          this.accounts = result.data.data;
          this.totalItems = result.data.totalRecords;
          this.loading = false;
        }
      });
    },

    open (item) {
      this.item = item;
      this.dialog = true;
    },

    close () {
      this.dialog = false;
    },

    changePage (pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.rowsPerPage;
      this.fetchDealerAccounts();
    },

    search () {
      let searchText = this.table.searchText;
      this.pagination.keySearch = searchText;
      this.pagination.pageIndex = 1;
      this.fetchDealerAccounts();
    },

    changeManager (rowId) {
      const answer = window.confirm('Xác nhận thay đổi người quản lí?');
      if (answer) {
        const body = {
          accountId: this.item.id,
          managedByUserId: rowId
        };
        updatemanageduser(body).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            this.close();
            this.$emit('changeSuccess');
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.loading-export{
 position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.4);
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.loading-export >>> .v-progress-circular{
  flex: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/DialogManager.vue